<div id="filter" class="filter-box general-box">
  <span class="icon-close" (click)="closeFilter()"></span>
  <div class="item-box">
    <h2 class="h-special">{{ 'FILTERS' | translate }}</h2>
    <div class="item-ctent">
      <p class="txt-filter"> {{ 'Please scroll down and select the appropriate filters to refine and visualize the quiet areas, according to noise levels, descriptors, perceived quietness, visual quality, accessibility and time.' | translate }}</p>
    </div>
  </div>
  <div class="noise-filter">
    <div class="item-box">
      <h2 class="h-special">{{ 'NOISE LEVELS' | translate }}</h2>
      <div class="item-ctent">
        <div [ngClass]="{ 'no-color' : isChecked === false }" class="noiseshell" id="noiseshell">
          <div class="noisetrack bg-gradient" id="noisetrack"></div>
          <div class="noisefill" id="noisefill"></div>
          <div class="noisethumb" id="noisethumb"></div>
          <div class="noisevalue" id="noisevalue">0</div>
          <input class="noise-level" id="noise-level" type="range" min="20" max="75" value="40" disabled="disabled">
        </div>
        <ul id="list-noise" class="list-noise">
          <li>20</li>
          <li>30</li>
          <li>40</li>
          <li>50</li>
          <li>60</li>
          <li>70</li>
          <li>>75 dB</li>
        </ul>
        <label class="label-check">
          <input type="checkbox" name="checklevel" id="checklevel" (change)="onChecked($event)"> {{ 'Flag here if you want to filter the noise levels.' | translate }}
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
  <div class="descriptors-filter">
    <div class="item-box">
      <h2 class="h-special">{{ 'DESCRIPTORS' | translate }}</h2>
      <div class="item-ctent">
        <ul id="list-descriptors" class="list-descriptors">
          <li *ngFor="let des of arrayDescriptors" [class]="des.class" [attr.data-value]="des.text">{{ des.text | translate }}</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="perceived-filter">
    <div class="item-box">
      <h2 class="h-special">{{ 'PERCEIVED QUIETNESS' | translate }}</h2>
      <div class="item-ctent">
        <div class="visual-select">
          <p class="show-visual" (click)="toggleSelect($event)">{{ textPerceived }}</p>
          <ul id="perceived" class="list-visual">
            <li *ngFor="let visual of arrayPerceived" [attr.data-value]="visual.value">{{ visual.text | translate }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="visual-filter">
    <div class="item-box">
      <h2 class="h-special">{{ 'VISUAL QUALITY' | translate }}</h2>
      <div class="item-ctent">
        <div class="visual-select">
          <p class="show-visual" (click)="toggleSelect($event)">{{ textVisual }}</p>
          <ul id="visual" class="list-visual">
            <li *ngFor="let visual of arrayVisual" [attr.data-value]="visual.value">{{ visual.text | translate }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="accessibility-filter">
    <div class="item-box">
      <h2 class="h-special">{{ 'ACCESSIBILITY' | translate }}</h2>
      <div class="item-ctent">
        <div class="visual-select">
          <p class="show-visual" (click)="toggleSelect($event)">{{ textAccessibility }}</p>
          <ul id="accessibility" class="list-visual">
            <li *ngFor="let visual of arrayAccessibility" [attr.data-value]="visual.value">{{ visual.text | translate }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="time-filter">
    <div class="item-box">
      <h2 class="h-special">{{ 'TIME' | translate }}</h2>
      <div class="item-ctent">
        <div class="visual-select">
          <p class="show-visual" (click)="toggleSelect($event)">{{ textTime }}</p>
          <ul id="time" class="list-visual">
            <li *ngFor="let visual of arrayTime" [attr.data-value]="visual.value">{{ visual.text | translate }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="text-center mt-3">
    <button class="btn-apply" (click)="applyFilter()">{{ 'Apply' | translate }}</button>
    <button class="btn-reset" (click)="resetFilter()">{{ 'Reset' | translate }}</button>
  </div>
</div>